__turbopack_context__.v({
  "active": "EBBMenu-module__f7ufzW__active",
  "dropdownArrow": "EBBMenu-module__f7ufzW__dropdownArrow",
  "ebbMenu": "EBBMenu-module__f7ufzW__ebbMenu",
  "emptyColumn": "EBBMenu-module__f7ufzW__emptyColumn",
  "hasSubmenu": "EBBMenu-module__f7ufzW__hasSubmenu",
  "megaMenu": "EBBMenu-module__f7ufzW__megaMenu",
  "megaMenuChild": "EBBMenu-module__f7ufzW__megaMenuChild",
  "megaMenuChildren": "EBBMenu-module__f7ufzW__megaMenuChildren",
  "megaMenuColumn": "EBBMenu-module__f7ufzW__megaMenuColumn",
  "megaMenuGroup": "EBBMenu-module__f7ufzW__megaMenuGroup",
  "megaMenuGroupHeader": "EBBMenu-module__f7ufzW__megaMenuGroupHeader",
  "megaMenuInner": "EBBMenu-module__f7ufzW__megaMenuInner",
  "megaMenuRow": "EBBMenu-module__f7ufzW__megaMenuRow",
  "menuBackdrop": "EBBMenu-module__f7ufzW__menuBackdrop",
  "menuChevron": "EBBMenu-module__f7ufzW__menuChevron",
  "menuColumn": "EBBMenu-module__f7ufzW__menuColumn",
  "menuIcon": "EBBMenu-module__f7ufzW__menuIcon",
  "menuItem": "EBBMenu-module__f7ufzW__menuItem",
  "menuItemContent": "EBBMenu-module__f7ufzW__menuItemContent",
  "menuLink": "EBBMenu-module__f7ufzW__menuLink",
  "menuOpen": "EBBMenu-module__f7ufzW__menuOpen",
  "nestedMenuItem": "EBBMenu-module__f7ufzW__nestedMenuItem",
  "nestedMenuItemContainer": "EBBMenu-module__f7ufzW__nestedMenuItemContainer",
  "nestedSubMenu": "EBBMenu-module__f7ufzW__nestedSubMenu",
  "subMenu": "EBBMenu-module__f7ufzW__subMenu",
  "subMenuItem": "EBBMenu-module__f7ufzW__subMenuItem",
  "subMenuItemContainer": "EBBMenu-module__f7ufzW__subMenuItemContainer",
});
